var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative flex justify-end items-center ml-auto mr-0" },
    [
      _c(
        "button",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.hide,
              expression: "hide",
            },
          ],
          staticClass:
            "w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100 transition ease-in-out duration-150",
          attrs: {
            id: "project-options-menu-0",
            "aria-has-popup": "true",
            type: "button",
          },
          on: { click: _vm.toggle },
        },
        [
          _c(
            "svg",
            {
              staticClass: "w-5 h-5",
              attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z",
                },
              }),
            ]
          ),
        ]
      ),
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": "ease-in-out duration-300",
            "enter-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "ease-in-out duration-300",
            "leave-class": "opacity-100",
            "leave-to-class": "opacity-0",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show,
                  expression: "show",
                },
              ],
              staticClass:
                "mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 rounded-md shadow-lg z-10",
            },
            [
              _c(
                "div",
                {
                  staticClass: "z-10 rounded-md bg-white shadow-xs",
                  attrs: {
                    role: "menu",
                    "aria-orientation": "vertical",
                    "aria-labelledby": "project-options-menu-0",
                  },
                },
                [_vm._t("default")],
                2
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }